import React from "react";
import { ITableModel } from "components/Table/interface";
import { ILostItemRow } from "./LostItemsDetailDropdown";

function CellNoWrap({ value }: { value: string | undefined }) {
  const text = value ?? "-";
  return (
    <span
      className="color-blue-gray"
      style={{
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        display: "block",
        maxWidth: "100%",
      }}
      title={text}
    >
      {text}
    </span>
  );
}

export function lostItemsTableModel(): ITableModel[] {
  return [
    {
      label: "Código",
      key: "code",
      size: 205,
      maxSize: 205,
      noFilter: true,
      Component: (data: ILostItemRow) => <CellNoWrap value={data.productCode} />,
    },
    {
      label: "Descrição",
      key: "description",
      size: 600,
      maxSize: 600,
      noFilter: true,
      Component: (data: ILostItemRow) => (
        <span
          className="color-blue-gray"
          title={data.productDescription ?? "-"}
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical" as const,
            overflow: "hidden",
            wordBreak: "break-word",
          }}
        >
          {data.productDescription ?? "-"}
        </span>
      ),
    },
    {
      label: "Marca",
      key: "brand",
      size: 325,
      maxSize: 325,
      noFilter: true,
      Component: (data: ILostItemRow) => (
        <span
          className="color-blue-gray"
          title={data.brand ?? "-"}
          style={{
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical" as const,
            overflow: "hidden",
            wordBreak: "break-word",
          }}
        >
          {data.brand ?? "-"}
        </span>
      ),
    },
  ];
}
